import { useState } from 'react';
import { Title } from '../components/title';
import { Search } from '../components/home/search';
import { MainNav } from '../components/home/main-nav';
import { type Doc, useSearch } from './search';
import { X, Menu } from 'lucide-react';
import { RARITY_MAP } from '@/constants';
import styles from './gallery.module.css';

const Item = ({ doc }: { doc: Doc }) => {
  return (
    <div
      key={ doc.id }
      className={ styles.item }
      data-rarity={ doc.rarity }
    >
      <div
        className={ styles.image }
        data-squishy-background={ doc.id }
      />
      <p>
        { doc.name }
      </p>
    </div>
  );
};

const GalleryContent = () => {
  const [checked, setChecked] = useState(false);
  const {
    value,
    results,
    onChange,
  } = useSearch();
  
  const docs = checked ? 
    [...results].sort((a, b) => {
      const rarityA = RARITY_MAP.get(a.rarity) ?? Number.MAX_SAFE_INTEGER;
      const rarityB = RARITY_MAP.get(b.rarity) ?? Number.MAX_SAFE_INTEGER;
      if (rarityA !== rarityB) return rarityA - rarityB;
      return a.name.localeCompare(b.name);
    }) as Doc[]
    : results;

  return (
    <>
      <header className={ styles.filters }>
        <form className={ styles.search }>
          <input
            type="text"
            placeholder="Search squishies..."
            value={ value }
            onChange={ onChange }
          />
        </form>

        <label className={ styles.switch }>
          <input
            type="checkbox"
            checked={ checked }
            onChange={ () => setChecked(!checked) }
          />
          <span>
            Name
          </span>
          <span>
            Rarity
          </span>
        </label>
      </header>
      <div className={ styles.gallery }>
        { docs.map(doc => {
          return <Item key={ doc.id } doc={ doc } />;
        }) }
      </div>
    </>
  );
};

export const Gallery = () => {
  const [menuActive, setMenuActive] = useState(false);
  return (
    <>
      <Title title="Gallery" />
      <div className={ styles.layout }>
        <header className={ styles.header }>
          <div data-menu={ menuActive }>
            <h1 className={ styles.siteTitle }>
              <span>
                icklesquishy.bot
              </span>
              <button
                type="button"
                className={ styles.menuButton }
                onClick={ () => setMenuActive(!menuActive) }
              >
                { menuActive ? <X /> : <Menu /> }
                <span className="visually-hidden">Menu</span>
              </button>
            </h1>
            <Search />
            <MainNav />
          </div>
        </header>
        <main className={ styles.main }>
          <div>
            <h1 className={ styles.title }>
              Gallery
            </h1>
            <GalleryContent />
          </div>
        </main>
      </div>
    </>
  );
};